import { Staking } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike, ZeroAddress } from "ethers";

export type StakeData = {
  active: boolean;
  amount: bigint;
  activeFrom: bigint;
  staker: AddressLike;
  token: AddressLike;
}

export async function GetLockAmount(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, token: AddressLike, user: AddressLike): Promise<bigint> {
  const staking = contracts.getContractByName(ContractName) as unknown as Staking;
  return await staking.getLockAmount(user, token);
}

export async function GetStakeData(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, token: AddressLike, user: AddressLike): Promise<StakeData> {
  const staking = contracts.getContractByName(ContractName) as unknown as Staking;
  const stakeData = await staking.getStakeData(user, token);
  return {
    active: stakeData.active,
    amount: stakeData.amount,
    activeFrom: stakeData.activeFrom,
    staker: stakeData.staker,
    token: stakeData.token,
  } as StakeData;
}

export const GetterMethods = {
  GetLockAmount,
  GetStakeData,
};

export default GetterMethods;